import React from 'preact/compat';
import { Field } from 'formik';
import { restrictInput } from '../../../lib/form';
import FormLabel from '../label';
import FormError from '../error';

export default function BasicFields() {
    return (
        <div className='form__grid-item  form__grid-item--wide  form__grid'>
            <div className='form__grid-item  form__field'>
                <FormLabel htmlFor='firstName' required={true}>First name</FormLabel>
                <Field name='firstName' id='firstName' className='input  input--text' />
                <FormError name='firstName' />
            </div>
            <div className='form__grid-item  form__field'>
                <FormLabel htmlFor='lastName' required={true}>Last name</FormLabel>
                <Field name='lastName' id='lastName' className='input  input--text' />
                <FormError name='lastName' />
            </div>
            <div className='form__grid-item  form__field'>
                <FormLabel htmlFor='email' required={true}>Email</FormLabel>
                <Field type='email' name='email.first' id='email' className='input  input--text' />
                <FormError name='email.first' />
            </div>
            <div className='form__grid-item  form__field'>
                <FormLabel htmlFor='confirmEmail' required={true}>Confirm email</FormLabel>
                <Field type='email' name='email.second' id='confirmEmail' className='input  input--text' />
                <FormError name='email.second' />
            </div>
            <div className='form__grid-item  form__field'>
                <FormLabel htmlFor='telephone' required={true}>Telephone</FormLabel>
                <Field type='tel' name='telephone' id='telephone' onKeyPress={restrictInput(/[\d\s]/)} className='input  input--text' />
                <FormError name='telephone' />
            </div>
        </div>
    );
}
